import { Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "app-no-access-labs",
  templateUrl: "./no-access-labs.component.html",
  styleUrls: ["./no-access-labs.component.scss"],
  host: { class: "no-access-labs-component" },
})
export class NoAccessLabsComponent {
  @Output() sendRequest = new EventEmitter();
}
